import { FunctionalComponent, h } from 'preact'
import {
  defineCustomElements,
  applyPolyfills,
} from '@globalonmedia/ui-components/dist/loader/index'

import { Provider } from 'overmind-react'
import { overmind, useOvermind } from '../overmind'

const AppContent: FunctionalComponent = () => {
  const { state } = useOvermind()
  const { menu, languages, footerText, footerContent } = state.app
  const [menuStr, languagesStr, footerTextStr, footerContentStr] = [
    menu,
    languages,
    footerText,
    footerContent,
  ].map((content) => (typeof content === 'string' ? content : JSON.stringify(content)))

  return (
    <df-app-provider>
      <df-header menu={menuStr} languages={languagesStr} />
      <div id="app">
      </div>
      <df-footer text={footerTextStr} content={footerContentStr} />
    </df-app-provider>
  )
}

const App: FunctionalComponent = () => {
  return (
    <Provider value={overmind}>
      <AppContent />
    </Provider>
  )
}

void applyPolyfills().then(() => {
  void defineCustomElements()
})

export default App
